import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css';

import toastConfig, { TX_STATUS_TOAST_ID } from './config';
import { UsingDevKey } from 'utils/Dev';
import './styles.scss';

const bsc_explorer = 'https://bscscan.com/';

export async function HandleTransactionPromise(promise) {
  console.warn(`HandleTransactionPromise is deprecated; use wonky Wagmi hook approach instead`);

  return toast.promise(
    promise,
    {
      pending: ToastProgressTx(),
      success: ToastSuccessTx(),
      error: ToastErrorTx(),
    }
  )
}

/* test tx Promise; use this inside one of the cards */
/*
useEffect(() => {
  HandleTransactionPromise(async () => {
    await new Promise(resolve => setTimeout(resolve, 1000));
    return '0x17ea8c71b0fbfa7194e3133b606beb957225b584cc2d204a15049e25a7788e48';
  }, gameDetails);
}, []);
*/




export function ToastProgressTx() {
  const conf = {
      ...toastConfig.transaction,
      autoClose: 60 * 1000,
      hideProgressBar: true,
      icon: false,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
    };

  if (toast.isActive(TX_STATUS_TOAST_ID)) {
    toast.update(
      TX_STATUS_TOAST_ID,
      {
        ...conf,
        render: () => 'Transacting...',
      }
    );
  } else {
    toast(
      () => 'Transacting...',
      conf,
    );
  }
}



export function ToastSuccessTx(txHash) {
  const conf = {
    ...toastConfig.transaction,
    type: 'success',
    data: {
      txHash: txHash
    }
  }
  if (toast.isActive(TX_STATUS_TOAST_ID)) {
    toast.update(
      TX_STATUS_TOAST_ID,
      {
        ...conf,
        render: _RenderSuccessToast,
      }
    );
  } else {
    toast(
      _RenderSuccessToast,
      conf,
    );
  }

}

function _RenderSuccessToast({ closeToast, data, isPaused, toastProps }) {
  return (<div style={{ display: 'flex', flexDirection: 'column' }}>
    <p style={{ color: 'green' }}>Transaction successful!</p>
    <a className='ViewTx'
      href={bsc_explorer + 'tx/' + data.txHash} target="_blank" rel="noreferrer"
    >
      View transaction
    </a>
  </div>);
}



export function ToastErrorTx(errorText, txHash) {
  const conf = {
    ...toastConfig.transaction,
    type: 'error',
    data: {
      errorText: errorText,
      txHash: txHash
    }
  };
  if (toast.isActive(TX_STATUS_TOAST_ID)) {
    toast.update(
      TX_STATUS_TOAST_ID,
      {
        ...conf,
        render: _RenderErrorToast,
      }
    );
  } else {
    toast(
      _RenderErrorToast,
      conf,
    );
  }
};


function _RenderErrorToast({ closeToast, data, isPaused, toastProps }) {
  let txReceiptElement = null;
  if (data.txHash)
    txReceiptElement = (
      <a className='ViewTx'
        href={bsc_explorer + 'tx/' + data.txHash} target="_blank" rel="noreferrer"
      >
        View transaction
      </a>
    );

  return (<div style={{ display: 'flex', flexDirection: 'column' }}>
    <p style={{ color: 'red' }}>Failed: {data.errorText}</p>
    {txReceiptElement}
  </div>);
}
